import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContentItem } from '../../models/content/content-item.interface';

@Injectable({ providedIn: 'root' })
export class ResourcesForLearnersService {
	private readonly relativeUrl =
		'content/general/components/learnersResources/names/webinar';
	constructor(private readonly http: HttpClient) {}

	getResourceLearners(clientId: number): Observable<Array<ContentItem>> {
		return this.http.get<Array<ContentItem>>(
			`${this.relativeUrl}?cascade=true&client=${clientId}&textOnly=true`
		);
	}
}
